import React from 'react';

const ActivitiesLoadMoreButton = ({ onClick }) => (
  <div className="load-more-container text-center mt-4">
    <button
      onClick={onClick}
      className="btn-secondary inline-block"
    >
      Load more
    </button>
  </div>
);

export default ActivitiesLoadMoreButton;
